import React from "react";
import defaultUser from "assets/images/avatar.svg";
import { useSearchParams } from "react-router-dom";
import { getRelativeTime } from "utils";

const ChatList = ({
  chatsData,
  user,
  chatId,
  totalChats,
  handleViewMore,
  query,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getChatUser = (chat, user) => {
    if (user?.roleType === "CLIENT") return chat?.pilotId || chat?.adminId;
    if (user?.roleType === "PILOT") return chat?.clientId || chat?.adminId;
    if (user?.roleType === "ADMIN") return chat?.pilotId || chat?.clientId;
    return null;
  };

  return (
    <div className="chat-list">
      {chatsData?.length > 0 &&
        chatsData.map((chat, idx) => {
          const userData = getChatUser(chat, user);
          if (!userData) return null;

          return (
            <div
              onClick={() => setSearchParams({ id: chat?._id })}
              className={`cursor-pointer p-3 d-flex notify-outer justify-content-between align-items-start ${
                chatId === chat?._id ? "active-chat" : ""
              }`}
              key={idx}
            >
              <div className="d-flex gap-2">
                <div>
                  <img
                    alt=""
                    src={`${user?.baseS3Url}${userData?.avatar}`}
                    className="round-img border border-secondary"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = defaultUser;
                    }}
                  />
                </div>
                <div>
                  <h6 className="mb-0">SK{chat?.jobId?.id}</h6>
                  <p className="mb-0 light-texts">{userData?.fullName}</p>
                </div>
              </div>
              <p className="light-texts">
                {chat?.updated ? getRelativeTime(chat?.updated) : ""}
              </p>
            </div>
          );
        })}
      {chatsData?.length < totalChats && !query && (
        <div className="d-flex flex-wrap gap-2 justify-content-center">
          <button className="blue-btnnn text-white" onClick={handleViewMore}>
            View More
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatList;
